<template>
  <div>
    <div class="vx-row">

      <!-- Doctor Master -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/4 mb-base">
        <vx-card
          class="master-card bg-light-blue"
          @click.native="go('/doctorMaster')"
        >
          <div class="count-badge">{{ totalDoctors }}</div>
          <div class="card-content">
            <UsersIcon class="card-icon" />
            <h4>Doctors</h4>
            <p>Manage doctors, specialization & schedules</p>
          </div>
        </vx-card>
      </div>
   <!-- Bill Master -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/4 mb-base">
        <vx-card
          class="master-card bg-light-orange"
          @click.native="go('/billMaster')"
        >
        <div class="count-badge">{{ totalBills }}</div>
          <div class="card-content">
            <CreditCardIcon class="card-icon" />
            <h4>Bills</h4>
            <p>Billing items, charges & tax setup</p>
          </div>
        </vx-card>
      </div>
      <!-- Room Master -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/4 mb-base">
        <vx-card
          class="master-card bg-light-yellow"
          @click.native="go('/roomMaster')"
        >
         <div class="count-badge">{{ totalRooms }}</div>
          <div class="card-content">
            <HomeIcon class="card-icon" />
            <h4>Rooms</h4>
            <p>Configure rooms, beds & availability</p>
          </div>
        </vx-card>
      </div>

   <!-- User Master -->
<div class="vx-col w-full sm:w-1/2 md:w-1/3 lg:w-1/4 mb-base">
  <vx-card
    class="master-card bg-light-purple"
    @click.native="go('/userMaster')"
  >
    <div class="count-badge">{{ totalUsers }}</div>
    <div class="card-content">
      <UserIcon class="card-icon" />
      <h4>Users</h4>
      <p>Manage system users & access</p>
    </div>
  </vx-card>
</div>

    </div>
  </div>
</template>


<script>
import { UsersIcon, HomeIcon, CreditCardIcon, UserIcon } from 'vue-feather-icons'

export default {
  components: {
    UsersIcon,
    HomeIcon,
    CreditCardIcon,
    UserIcon 
  },
  data(){
    return {
    totalDoctors: 0,
    totalBills: 0,
    totalRooms: 0,
     totalUsers: 0
}

  },
  mounted() {
    this.getMasterDashboardStats();
},

  methods: {
    go(path) {
      this.$router.push(path)
    },
    getMasterDashboardStats() {
    var request = {
        companyId: this.$session.get('companyId')
    };

    this.$http.post(
        'masterDashboardStats',
        JSON.stringify(request),
        {
            headers: {
                "Content-Type": "application/json"
            }
        }
    )
    .then(response => {
        console.log("master dashboard data", response.data);

        this.totalDoctors = response.data.data.totalDoctors;
        this.totalBills = response.data.data.totalBillItems

        this.totalRooms = response.data.data.totalRooms;
    });
},

  }
}
</script>
<style scoped>

.master-card {
  position: relative;   /* important */
  height: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.count-badge {
  position: absolute;
  top: 10px;
  right: 12px;
  background: #6a5eeb;
  color: #fff;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
}

.master-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.12);
}

.card-content {
  text-align: center;
  padding: 20px;
}

.card-icon {
  width: 30px;
  height: 30px;
  margin-bottom: 12px;
}


.bg-light-blue {
  background: #e8f9f8;
}

.bg-light-yellow {
  background: #fff8d6;
}

.bg-light-orange {
  background: #ffe9d6;
}
.bg-light-purple {
  background: #f3ecff;
}
.card-content h4 {
  font-weight: 600;
  margin-bottom: 6px;
}

.card-content p {
  font-size: 13px;
  opacity: 0.75;
}

</style>